module.exports = __webpack_public_path__ + "band_16.303c9fb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male/band_16.png
// module id = 3fOx
// module chunks = 0